var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_vm._m(0),_c('div',{staticClass:"back-wrap"},[_c('span',[_vm._v("访问的页面不存在~~~，")]),_c('span',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("返回首页>>")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404-content"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/img/404.png")}})])
}]

export { render, staticRenderFns }